import O1HD from "../../../engines/gameEngine";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../../modes/define/FileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class healBeriberiStartPage extends cc.Component {

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"按钮layout"})
    btnLayout:cc.Node = null;

    start(){
        O1HD.getModules().uiControlModule.hideLoading();
        this.btnLayout.active = false;
    }

    onBtnNotSave(){
        this.node.destroy();
    }

    onBtnSave(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.healBeriberiGameLayer,null,null,null,()=>{
                this.node.destroy();
            }
        );
    }

    canClickPeople:boolean = true;

    async onClickPeople(){
        if(!this.canClickPeople){
            if (!this.btnLayout.active) {
                this.unschedule(this.showSecond);
                this.showSecond();
            }
            return;
        }
        this.canClickPeople = false;
        this.showOneChat(true,"前天在宫里看到一双水晶鞋，试穿了一下，结果鞋子太小了",6);
        this.scheduleOnce(this.showSecond, 5.8);
        
    }

    showSecond() {
        this.showOneChat(true,"卡伤了我的脚还被感染了脚气，被老婆赶出了家",9999999999);
        this.btnLayout.active = true;
    }

    async showOneChat(showOrHide:boolean,chat?:string,delayTime:number = 5){
        cc.Tween.stopAllByTarget(this.chatNode);
        return new Promise<void>(resolve=>{
            if(showOrHide){
                let lbChat:cc.Label = this.chatNode.getChildByName("label").getComponent(cc.Label);
                lbChat.string = chat;
                cc.tween(this.chatNode).to(0.2,{scale:1},{easing:cc.easing.backOut}).delay(delayTime).call(async ()=>{
                    await this.showOneChat(false);
                    resolve();
                }).start();
            }else{
                cc.tween(this.chatNode).to(0.2,{scale:0},{easing:cc.easing.backIn}).call(resolve).start();
            }
        });
    }

    onBtnBack(){
        this.node.destroy();
    }

}
